/* eslint-disable react/jsx-props-no-multi-spaces */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Col, Input, Label, Row } from 'reactstrap';
import DropdownSelect from '../../ProposalGenerator/DropdownSelect';

const MainEnterprise = memo(({ state, onStateChange, groupItems }) => {
  const companies =
    useSelector(state_ => state_.AppState.companies)?.docs?.map(company => ({
      value: company._id,
      label: company.name,
    })) || [];

  return (
    <div className="mt-3 mb-3">
      <Row>
        <Col sm={4}>
          <Label className="mt-3">Group Name:</Label>
          <Input
            placeholder="Group Name"
            required
            type="text"
            name="name"
            value={state.name}
            onChange={e => onStateChange(e.target.value, 'name')}
          />
          <Label className="mt-3">Management Company:</Label>
          <DropdownSelect
            options={companies}
            selectedOption={state.company}
            onSelect={value => {
              onStateChange(value, 'company');
              // addCompanyGroupChange({ name: 'hostTag', value: value.value });
            }}
          />
        </Col>
      </Row>
    </div>
  );
});

export default MainEnterprise;
